import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/www/www/src/app/campaign-redirect/[slug]/redirect-client.tsx");
